<script lang="ts" setup>
const props = defineProps({
  title: {
    type: String,
    default: '',
  },

  small: {
    type: Boolean,
    default: false,
  },

  tiny: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div class="info-card box-border pt-24">
    <div
      class="relative box-border h-full border-[1px_solid_rgba(154,158,166,0.1)] rounded-4 bg-white shadow-[0_0_16px_0_rgba(0,0,0,0.08)]"
      :class="[
        $slots.title || props.title ? 'pt-40' : 'pt-32',
        props.small || props.tiny ? 'pb-24' : 'pb-32',
        props.tiny ? 'px-24' : 'px-32',
      ]"
    >
      <div class="absolute left-50% top-0 m-0 box-border h-48 min-w-178 whitespace-nowrap rounded-2 bg-brand-primary px-32 text-center text-16 text-white font-normal leading-48 -translate-50%" v-if="$slots.title">
        <slot name="title"></slot>
      </div>
      <h3 class="absolute left-50% top-0 m-0 box-border h-48 min-w-178 whitespace-nowrap rounded-2 bg-brand-primary px-32 text-center text-16 text-white font-normal leading-48 -translate-50%" v-else-if="props.title">
        {{ props.title }}
      </h3>

      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
